const InsertPosition = {
	Before: 'beforebegin',
	After: 'afterend',
	BeforeFirst: 'afterbegin',
	AfterLast: 'beforeend',
};

const InsertPositionLabels = {
	[InsertPosition.Before]: 'Before element',
	[InsertPosition.After]: 'After element',
	[InsertPosition.BeforeFirst]: 'First child',
	[InsertPosition.AfterLast]: 'Last child',
};

/**
 * Distance type for minPixelDistance setting.
 * Controls how the minimum distance between ads is calculated.
 */
const DistanceType = {
	Pixels: 'pixels',
	Percent: 'percent',
};

const MaxInsertsPerPage = {
	default: 5,
	min: 1,
	max: 30,
};

const DefaultConfig = {
	scanInterval: 500,
	maxScanInterval: 5000,
	pixels: 2400,
	enableBackgroundScan: false,
	includeMargins: true,
	friendlyCustomParam: 'Dynamic Placement',
	maxScanDuration: 16,
	maxAnchorsPerScan: 200,
};

/** Field names to keep as recognized fields (but hide in UI) when DI is not enabled. */
const FieldNames = ['rlvDynamicInsert', 'rlvDynamicInsertion'];

module.exports = {
	InsertPosition,
	InsertPositionLabels,
	DistanceType,
	MaxInsertsPerPage,
	DefaultConfig,
	FieldNames,
};
